<div class="panel" [@childAnimation] clickOutside (isClickOutside)="handleClickOutside()">
  <div class="fechar">
    <img (click)="dismiss.emit()" src="../assets/svg/Group.svg" alt=""/>
  </div>
  <br/>
  <br/>
  <div class="d-flex flex-column body-info">
    <div class="info-contract contractInfos">
      <p>Contrato</p>
      <p id="contractNameResponsive">{{ companyName.id }} - {{ companyName?.description }} </p>
      <p id="contractDocumentNumber">{{ companyName?.documentNumberCompanyContract | mask: '00.000.000/0000-00' }}</p>
    </div>
    <div class="tollBalanceComponent">
      <app-toll-balance></app-toll-balance>
    </div>
    <div class="sidebar">
      <ul class="nav-links" id="nav-links">
        @for (item of menuSidebar; track item) {
          <li #itemEl routerLinkActive="active">
            <!--  menu sem submenu -->
            @if (item.sub_menu.length == 0) {
              <div class="dropdown-title">
                @if (item?.accessControl) {
                  <div>
                    <a class="menu-item" *accessControl="item?.accessControl" [routerLink]="[item.link]" [routerLinkActive]="[item?.linkActive]">
                      @if (item?.icon) {
                        <img src="{{item.icon}}" class="img-title"/>
                      }
                      <span class="link_name">{{ item.link_name.toLocaleUpperCase() }}</span>
                    </a>
                  </div>
                } @else {
                  @if (item.link_name.toLocaleUpperCase() !== 'SAIR' && item.link_name.toLocaleUpperCase() !== 'TROCAR CONTRATO') {
                    <a class="menu-item"
                      [routerLink]="[item.link]" [routerLinkActive]="[item?.linkActive]">
                      @if (item?.icon) {
                        <img src="{{item.icon}}" class="img-title"/>
                      }
                      <span class="link_name">{{ item.link_name.toLocaleUpperCase() }}</span>
                    </a>
                  }
                  @if (item.link_name.toLocaleUpperCase() === 'TROCAR CONTRATO' && (this.haveManyContracts || this.hasChangeContractButton)) {
                    <a class="menu-item"
                      [routerLink]="[item.link]" [routerLinkActive]="[item?.linkActive]">
                      @if (item?.icon) {
                        <img src="{{item.icon}}" class="img-title"/>
                      }
                      <span class="link_name">{{ item.link_name.toLocaleUpperCase() }}</span>
                    </a>
                  }
                  @if (item.link_name.toLocaleUpperCase() === 'SAIR') {
                    <a class="menu-item"
                      (click)="logout()">
                      @if (item?.icon) {
                        <img src="{{item.icon}}" class="img-title"/>
                      }
                      <span class="link_name">{{ item.link_name.toLocaleUpperCase() }}</span>
                    </a>
                  }
                }
              </div>
            }
            <!--  menu com submenu -->
            @if (item.sub_menu.length > 0) {
              <div class="dropdown-title" (click)="showSubmenu(itemEl, item)">
                <a class="menu-item">
                  <img src="{{item.icon}}" class="col-1 img-title"/>
                  <span class="link_name">{{ item.link_name.toLocaleUpperCase() }}</span>
                  <a id="{{generateDynamicIDElement(item)}}" class="img-menu-close"></a>
                </a>
              </div>
            }
            <!--  submenu -->
            <ul class="sub-menu" [class.blank]="item.sub_menu.length == 0">
              <li><a class="menu-item link_name">{{ item.link_name.toLocaleUpperCase() }}</a></li>
              @for (item_sub of item.sub_menu; track item_sub) {
                <li routerLinkActive="active">
                  @if (item_sub.modalityType != null) {
                    <div>
                      <div *modalityType="item_sub?.modalityType">
                        <a class="submenu-item" *accessControl="item_sub?.accessControl"
                        [routerLink]="[item_sub.link]">{{ item_sub.link_name }}</a>
                      </div>
                    </div>
                  }
                  @if (item_sub.modalityType == null) {
                    <div>
                      <a class="submenu-item" *accessControl="item_sub?.accessControl" [routerLink]="[item_sub.link]">{{ item_sub.link_name }}</a>
                    </div>
                  }
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
